import { Button, HStack, Image, Popover, PopoverContent, PopoverTrigger, Stack, useMediaQuery } from '@chakra-ui/react'
import useAuth from '../hooks/useAuth'
import { useNavigate } from 'react-router-dom'
import SessionStartLogo from './SessionStartLogo'

const quilmesImages = require.context('../assets/images', true)

const LogoutHeader = () => {
  const { logout, setUserRegister } = useAuth()
  const navigate = useNavigate()
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')

  const handleLogout = async () => {
    try {
      await logout()
      sessionStorage.removeItem('user')
      setUserRegister({})
      navigate('/')
    } catch (error) {
      console.error(error.message)
    }
  }

  return (
    <>
      <HStack
        {...(isLargerThan768
          ? { width: '45%', padding: '0 20px' }
          : { width: '90%', padding: '0 20px' })}
      >
        <SessionStartLogo />
      </HStack>
      {isLargerThan768
        ? (
          <Stack
            direction='row'
            spacing={4}
            {...(isLargerThan768
              ? { padding: '0 20px' }
              : { display: 'none', padding: '0 0px' })}
          >
            <Button
              _active={{ bg: 'transparent' }}
              _hover={{ bg: 'transparent' }}
              bg={'transparent'}
              leftIcon={<Image src={quilmesImages('./log_out.svg')} />}
              variant='solid'
              onClick={handleLogout}
            >
              Cerrar sesión
            </Button>
          </Stack>
        )
        : (
          <Popover>
            <PopoverTrigger>
              <Button
                _active={{ bg: 'transparent' }}
                _hover={{ bg: 'transparent' }}
                bg={'transparent'}
              >
                <Image
                  {...(isLargerThan768
                    ? { display: 'none' }
                    : { display: 'block', paddingRight: '10px' })}
                  src={quilmesImages('./puntosMobile.svg')}
                  width={'100%'}
                />
              </Button>
            </PopoverTrigger>
            <PopoverContent
              className='btn-close'
              marginLeft={'-20px'}
              w={'100%'}
            >
              <Button
                _active={{ bg: 'transparent' }}
                _hover={{ bg: 'transparent' }}
                bg={'transparent'}
                className='btn-close'
                fontSize={'13px'}
                leftIcon={
                  <Image
                    h={'20px'}
                    src={quilmesImages('./log_out.svg')}
                    w={'20px'}
                  />
                }
                padding={'1.5rem'}
                variant='solid'
                onClick={handleLogout}
              >
                Cerrar sesión
              </Button>
            </PopoverContent>
          </Popover>
        )}
    </>
  )
}

export default LogoutHeader
